<template>
<div tabindex="0" class="e-card" id="stage">
  <div class="e-card-title" style="display: inline-block">Update Email Stage Template</div>
    <div>
      <div class="e-card-content">
        <div class="form-row" v-if="muniMessage">
          <div style="width:80%;" class="form-row-input">
             <ejs-textbox float-label-type="Always" v-if="!isNew && muniMessage"
                        placeholder="municipality Name:"
                        v-model="muniMessage.muniName"
                        readonly="true"
             />
             <ejs-dropdownlist v-if="isNew && municipalities"
                float-label-type="Always"
                :data-source="municipalities"
                :fields="municipalitiesFields"
                v-model="muniMessage.muniName"
                :change="onMuniSelection"
                placeholder='Select a Municipality'>
                </ejs-dropdownlist>
          </div>
        </div>

        <div class="form-row" v-if="muniMessage">
           <div style="width:80%;" class="form-row-input">
            <ejs-textbox float-label-type="Always"
                        placeholder="Muni Code:"
                        v-model="muniMessage.muniCode"
                        readonly="true"
            />
          </div>
        </div>
        <div class="form-row" v-if="muniMessage">
           <div style="width:80%;" class="form-row-input">
            <ejs-textbox float-label-type="Always"
                        placeholder="Accreditation Number:"
                        v-model="muniMessage.accreditationNumber"
                        readonly="true"
            />
          </div>
        </div>
        <div style="width:80%;" class="form-row-input">
          Message:
        </div>
        <div class="form-row" v-if="muniMessage">
            <div style="width:80%;" class="form-row-input">
              <scc-input-validator :rules="[requiredRule]"
                :value="muniMessage.whereToGetPermit"
                @validate="v => this.isTemplateValid=v">
                <ejs-richtexteditor ref="refTemplate"
                height="340"
                width="100%"
                float-label-type="Always"
                placeholder="Message"
                :toolbarSettings="toolbarSettings"
                v-model="muniMessage.whereToGetPermit"
                >
                </ejs-richtexteditor>
              </scc-input-validator>
            </div>
        </div>
        <div style="width:100%;">
            <ejs-button type="button" v-on:click.native="onSubmitButtonClick"
                        cssClass="e-info margin-button">Submit</ejs-button>
            <ejs-button v-on:click.native="onCancelButtonClick"
                        cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  Image,
  HtmlEditor,
  QuickToolbar,
} from '@syncfusion/ej2-vue-richtexteditor';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import SccInputValidator from '@/components/base/scc-input-validator.vue';
import { FETCH_WHERE_TO_GET_PERMIT, POST_MUNICIPALITY_MESSAGE, FETCH_MUNI_WITHOUT_MESSAGE } from '../store'; // POST_MUNICIPALITY_MESSAGE

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(RichTextEditorPlugin);

export default {
  name: 'MunicipalityMessageEdit',
  provide: {
    richtexteditor: [Toolbar, Link, Count, Image, HtmlEditor, QuickToolbar],
  },
  components: {
    SccInputValidator,

  },
  data() {
    return {
      id: null,
      isTemplateValid: false,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      newMuniMessage: {
        muniName: null,
        muniCode: null,
        accreditationNumber: null,
        whereToGetPermit: '',
      },
      municipalitiesFields: { text: 'name', value: 'name' },
      toolbarSettings: {
        type: 'Expand',
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
          'LowerCase', 'UpperCase', '|',
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
          'Outdent', 'Indent', '|',
          'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
          'SourceCode', 'FullScreen', '|', 'Undo', 'Redo',
        ],
      },
    };
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id !== 'null') {
      this.id = this.$route.params.id;
      this.getMunicipalityMessage();
    } else {
      this.id = '';
      this.getMunicipalityWithoutMessage();
    }
  },
  created() {
  },

  computed: {
    muniMessage() {
      return this.isNew ? this.newMuniMessage : this.$store.getters.getWhereToGetPermit;
    },
    isNew() {
      return !this.id;
    },
    municipalities() {
      // console.log('muni', this.$store.getters.getMunicipalityWithoutMessage);
      return this.$store.getters.getMunicipalityWithoutMessage;
    },
  },

  methods: {
    onCancelButtonClick() {
      this.$router.push('/municipality-messages');
    },
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    async onSubmitButtonClick() {
      if (!this.isNew && (this.id === null || this.id === '')) {
        this.notify('Error', 'Missing primary key, cannot update!');
        return;
      }
      let formDataFail = false;
      let errorMessage = '';
      if (this.isNew && (this.muniMessage.muniName === null || this.muniMessage.muniName === '')) {
        formDataFail = true;
        errorMessage += 'Please select Municipality!<br>';
      }
      if (this.muniMessage.whereToGetPermit === null || this.muniMessage.whereToGetPermit === '') {
        formDataFail = true;
        this.isTemplateValid = false;
        errorMessage += 'Please check Mesage!<br>';
      } else {
        this.isAmountLevyValid = true;
      }
      if (formDataFail) {
        this.notify('Error', errorMessage);
        return;
      }
      try {
        const data = this.muniMessage;
        await this.$store.dispatch(POST_MUNICIPALITY_MESSAGE, { data });
        this.notify('Success', 'Municipality Message saved.');
      } catch (error) {
        this.notify('Error', 'Please verify the form data.');
      }
    },
    async getMunicipalityMessage() {
      try {
        if (this.id != null && this.id !== '') {
          const muniCode = this.id;
          await this.$store.dispatch(FETCH_WHERE_TO_GET_PERMIT, muniCode);
        }
      } catch (err) {
        const message = err.response.data.message ? err.response.data.message : 'Get Error when try to get Muncipality Messag';
        this.notify('Error', message);
      }
    },
    async getMunicipalityWithoutMessage() {
      try {
        await this.$store.dispatch(FETCH_MUNI_WITHOUT_MESSAGE);
      } catch (err) {
        const message = err.response.data.message ? err.response.data.message : 'Get Error when try to get Muncipality List';
        this.notify('Error', message);
      }
    },
    onMuniSelection(e) {
      const { itemData } = e;
      if (itemData !== null) {
        // this.$refs.searchCompanyName.ej2Instances.text = itemData.legalName;
        this.muniMessage.muniCode = itemData.code || '';
        this.muniMessage.accreditationNumber = itemData.accreditationNumber || '';
      } else {
        this.muniMessage.muniCode = '';
        this.muniMessage.accreditationNumber = '';
      }
    },
  },
};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 @import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";
 .e-card-content {
  margin: 0% !important;
}
</style>
